const currentDate = new Date();
const currentYear = currentDate.getFullYear();

const Months = Array.from({ length: 12 }, (_, i) =>
  new Date(currentYear, i).toLocaleString('default', { month: 'long' }));

export const monthOptions = Object.entries(Months)
  .filter(([_, value]) => typeof value === 'string')
  .map(([_, value]) => ({ label: value, value: value as string }));
